module.exports = __webpack_public_path__ + "static/img/5071_phase_function_Paper_Points.9d444a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5071_phase_function_Paper_Points.png
// module id = ubmw
// module chunks = 0